export function startEndOfTodayMs() {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  const end   = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1).getTime() - 1;
  return { start, end };
}